import { Modal, ModalAction } from './Modal'
import React from 'react'

export interface UseConfirmActions {
  onAccept: (cb?: () => void) => void
  onCancel?: (cb?: () => void) => void
}

export const useConfirm = () => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [content, setContent] = React.useState<React.ReactNode>()

  const [actions, setActions] = React.useState<UseConfirmActions>()

  const confirm = (
    modalContent: React.ReactNode,
    modalActions: UseConfirmActions,
  ) => {
    setContent(modalContent)
    setActions(modalActions)
    setIsOpen(true)
  }

  const createDialog = () => (
    <>
      <Modal
        title="Confirmation required"
        open={isOpen}
        actions={{
          [ModalAction.ACCEPT]: {
            onClick: () => {
              actions?.onAccept()
              setIsOpen(false)
            },
          },
          [ModalAction.CANCEL]: {
            onClick: () => {
              actions?.onCancel?.()
              setIsOpen(false)
            },
          },
        }}
        setOpen={setIsOpen}
      >
        {content}
      </Modal>
    </>
  )

  return { confirm, createDialog }
}
